export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9069.9602178b.jpg";